const deriveOrderItemsQuantity = (order) => {
  if (!order || !Array.isArray(order.items) || order.items.length === 0) {
    return undefined;
  }
  const total = order.items.reduce((acc, item) => {
    const quantity = Number(item?.quantity);
    if (Number.isFinite(quantity) && quantity > 0) {
      return acc + quantity;
    }
    return acc;
  }, 0);
  return total > 0 ? total : undefined;
};

const deriveOrderItemsName = (order) => {
  if (order && Array.isArray(order.items) && order.items.length > 0) {
    const names = order.items.map((item) => item?.item_name).filter(Boolean);
    if (names.length === 1) {
      return names[0];
    }
    if (names.length > 1) {
      return `${names[0]} (+${names.length - 1} more)`;
    }
  }
  return order?.item_name;
};

export const ALLEGRO_COLUMN_SPECS = [
  // 1
  { id: "row_number", label: "#", getter: (_order, index) => index + 1 },
  // 2
  { id: "id", label: "id", path: "id", fallback: (order) => order.allegro_order_id || order.id },
  // 3
  { id: "message_to_seller", label: "messageToSeller", path: "messageToSeller" },
  // 4
  { id: "buyer_id", label: "buyer. id", path: "buyer.id" },
  // 5
  { id: "buyer_email", label: "buyer. email", path: "buyer.email" },
  // 6
  { id: "buyer_login", label: "buyer. login", path: "buyer.login" },
  // 7
  { id: "buyer_first_name", label: "buyer. firstName", path: "buyer.firstName" },
  // 8
  { id: "buyer_last_name", label: "buyer. lastName", path: "buyer.lastName" },
  // 9
  { id: "buyer_company_name", label: "buyer. companyName", path: "buyer.companyName" },
  // 10
  { id: "buyer_guest", label: "buyer. guest", path: "buyer.guest" },
  // 11
  { id: "buyer_personal_identity", label: "buyer. personalIdentity", path: "buyer.personalIdentity" },
  // 12
  { id: "buyer_phone_number", label: "buyer. phoneNumber", path: "buyer.phoneNumber" },
  // 13
  { id: "buyer_preferences_language", label: "buyer.preferences. language", path: "buyer.preferences.language" },
  // 14
  { id: "buyer_address_street", label: "buyer.address. street", path: "buyer.address.street" },
  // 15
  { id: "buyer_address_city", label: "buyer.address. city", path: "buyer.address.city" },
  // 16
  { id: "buyer_address_post_code", label: "buyer.address. postCode", path: "buyer.address.postCode" },
  // 17
  { id: "buyer_address_country_code", label: "buyer.address. countryCode", path: "buyer.address.countryCode" },
  // 18
  { id: "payment_id", label: "payment. id", path: "payment.id" },
  // 19
  { id: "payment_type", label: "payment. type", path: "payment.type" },
  // 20
  { id: "payment_provider", label: "payment. provider", path: "payment.provider" },
  // 21
  { id: "payment_finished_at", label: "payment. finishedAt", path: "payment.finishedAt" },
  // 22
  {
    id: "payment_paid_amount_amount",
    label: "payment.paidAmount. amount",
    path: "payment.paidAmount.amount",
    fallback: (order) => order.selling_price,
  },
  // 23
  { id: "payment_paid_amount_currency", label: "payment.paidAmount. currency", path: "payment.paidAmount.currency" },
  // 24
  { id: "payment_reconciliation_amount", label: "payment.reconciliation. amount", path: "payment.reconciliation.amount" },
  // 25
  {
    id: "payment_reconciliation_currency",
    label: "payment.reconciliation. currency",
    path: "payment.reconciliation.currency",
  },
  // 26
  { id: "payment_features", label: "payment. features", path: "payment.features[]" },
  // 27
  { id: "status", label: "status", path: "status", fallback: (order) => order.allegro_status },
  // 28
  {
    id: "fulfillment_status",
    label: "fulfillment. status",
    path: "fulfillment.status",
    fallback: (order) => order.fulfillment_status,
  },
  // 29
  {
    id: "fulfillment_shipment_summary_line_items_sent",
    label: "fulfillment.shipmentSummary. lineItemsSent",
    path: "fulfillment.shipmentSummary.lineItemsSent",
  },
  // 30
  { id: "delivery_address_first_name", label: "delivery.address. firstName", path: "delivery.address.firstName" },
  // 31
  { id: "delivery_address_last_name", label: "delivery.address. lastName", path: "delivery.address.lastName" },
  // 32
  { id: "delivery_address_street", label: "delivery.address. street", path: "delivery.address.street" },
  // 33
  { id: "delivery_address_city", label: "delivery.address. city", path: "delivery.address.city" },
  // 34
  { id: "delivery_address_zip_code", label: "delivery.address. zipCode", path: "delivery.address.zipCode" },
  // 35
  { id: "delivery_address_country_code", label: "delivery.address. countryCode", path: "delivery.address.countryCode" },
  // 36
  { id: "delivery_address_company_name", label: "delivery.address. companyName", path: "delivery.address.companyName" },
  // 37
  { id: "delivery_address_phone_number", label: "delivery.address. phoneNumber", path: "delivery.address.phoneNumber" },
  // 38
  { id: "delivery_address_modified_at", label: "delivery.address. modifiedAt", path: "delivery.address.modifiedAt" },
  // 39
  { id: "delivery_method_id", label: "delivery.method. id", path: "delivery.method.id" },
  // 40
  { id: "delivery_method_name", label: "delivery.method. name", path: "delivery.method.name" },
  // 41
  { id: "delivery_pickup_point_id", label: "delivery.pickupPoint. id", path: "delivery.pickupPoint.id" },
  // 42
  { id: "delivery_pickup_point_name", label: "delivery.pickupPoint. name", path: "delivery.pickupPoint.name" },
  // 43
  {
    id: "delivery_pickup_point_description",
    label: "delivery.pickupPoint. description",
    path: "delivery.pickupPoint.description",
  },
  // 44
  {
    id: "delivery_pickup_point_address_street",
    label: "delivery.pickupPoint.address. street",
    path: "delivery.pickupPoint.address.street",
  },
  // 45
  {
    id: "delivery_pickup_point_address_zip_code",
    label: "delivery.pickupPoint.address. zipCode",
    path: "delivery.pickupPoint.address.zipCode",
  },
  // 46
  {
    id: "delivery_pickup_point_address_city",
    label: "delivery.pickupPoint.address. city",
    path: "delivery.pickupPoint.address.city",
  },
  // 47
  {
    id: "delivery_pickup_point_address_country_code",
    label: "delivery.pickupPoint.address. countryCode",
    path: "delivery.pickupPoint.address.countryCode",
  },
  // 48
  {
    id: "delivery_cost_amount",
    label: "delivery.cost. amount",
    path: "delivery.cost.amount",
    fallback: (order) => order.total_shipping_cost ?? order.shipping_cost,
  },
  // 49
  { id: "delivery_cost_currency", label: "delivery.cost. currency", path: "delivery.cost.currency" },
  // 50
  { id: "delivery_time_from", label: "delivery.time. from", path: "delivery.time.from" },
  // 51
  { id: "delivery_time_to", label: "delivery.time. to", path: "delivery.time.to" },
  // 52
  {
    id: "delivery_time_guaranteed_from",
    label: "delivery.time.guaranteed. from",
    path: "delivery.time.guaranteed.from",
  },
  // 53
  {
    id: "delivery_time_guaranteed_to",
    label: "delivery.time.guaranteed. to",
    path: "delivery.time.guaranteed.to",
  },
  // 54
  { id: "delivery_time_dispatch_from", label: "delivery.time.dispatch. from", path: "delivery.time.dispatch.from" },
  // 55
  { id: "delivery_time_dispatch_to", label: "delivery.time.dispatch. to", path: "delivery.time.dispatch.to" },
  // 56
  { id: "delivery_smart", label: "delivery. smart", path: "delivery.smart" },
  // 57
  {
    id: "delivery_calculated_number_of_packages",
    label: "delivery. calculatedNumberOfPackages",
    path: "delivery.calculatedNumberOfPackages",
    fallback: deriveOrderItemsQuantity,
  },
  // 58
  { id: "invoice_required", label: "invoice. required", path: "invoice.required" },
  // 59
  { id: "invoice_address_street", label: "invoice.address. street", path: "invoice.address.street" },
  // 60
  { id: "invoice_address_city", label: "invoice.address. city", path: "invoice.address.city" },
  // 61
  { id: "invoice_address_zip_code", label: "invoice.address. zipCode", path: "invoice.address.zipCode" },
  // 62
  { id: "invoice_address_country_code", label: "invoice.address. countryCode", path: "invoice.address.countryCode" },
  // 63
  { id: "invoice_address_company_name", label: "invoice.address.company. name", path: "invoice.address.company.name" },
  // 64
  {
    id: "invoice_address_company_ids_type",
    label: "invoice.address.company.ids. type",
    path: "invoice.address.company.ids[].type",
  },
  // 65
  {
    id: "invoice_address_company_ids_value",
    label: "invoice.address.company.ids. value",
    path: "invoice.address.company.ids[].value",
  },
  // 66
  {
    id: "invoice_address_company_vat_payer_status",
    label: "invoice.address.company. vatPayerStatus",
    path: "invoice.address.company.vatPayerStatus",
  },
  // 67
  { id: "invoice_address_company_tax_id", label: "invoice.address.company. taxId", path: "invoice.address.company.taxId" },
  // 68
  {
    id: "invoice_address_natural_person_first_name",
    label: "invoice.address.naturalPerson. firstName",
    path: "invoice.address.naturalPerson.firstName",
  },
  // 69
  {
    id: "invoice_address_natural_person_last_name",
    label: "invoice.address.naturalPerson. lastName",
    path: "invoice.address.naturalPerson.lastName",
  },
  // 70
  { id: "invoice_due_date", label: "invoice. dueDate", path: "invoice.dueDate" },
  // 71
  { id: "line_items_id", label: "lineItems. id", path: "lineItems[].id" },
  // 72
  {
    id: "line_items_offer_id",
    label: "lineItems.offer. id",
    path: "lineItems[].offer.id",
    fallback: (order) => {
      if (order && Array.isArray(order.items) && order.items.length > 0) {
        return order.items[0].allegro_offer_id;
      }
      return undefined;
    },
  },
  // 73
  {
    id: "line_items_offer_name",
    label: "lineItems.offer. name",
    path: "lineItems[].offer.name",
    fallback: deriveOrderItemsName,
  },
  // 74
  {
    id: "line_items_offer_external_id",
    label: "lineItems.offer.external. id",
    path: "lineItems[].offer.external.id",
  },
  // 75
  {
    id: "line_items_offer_product_set_products_id",
    label: "lineItems.offer.productSet.products. id",
    path: "lineItems[].offer.productSet.products[].id",
  },
  // 76
  {
    id: "line_items_offer_product_set_products_quantity",
    label: "lineItems.offer.productSet.products. quantity",
    path: "lineItems[].offer.productSet.products[].quantity",
  },
  // 77
  {
    id: "line_items_quantity",
    label: "lineItems. quantity",
    path: "lineItems[].quantity",
    fallback: deriveOrderItemsQuantity,
  },
  // 78
  {
    id: "line_items_original_price_amount",
    label: "lineItems.originalPrice. amount",
    path: "lineItems[].originalPrice.amount",
  },
  // 79
  {
    id: "line_items_original_price_currency",
    label: "lineItems.orginalPrice. currency",
    path: "lineItems[].originalPrice.currency",
  },
  // 80
  { id: "line_items_price_amount", label: "lineItems.price. amount", path: "lineItems[].price.amount" },
  // 81
  { id: "line_items_price_currency", label: "lineItems.price. currency", path: "lineItems[].price.currency" },
  // 82
  {
    id: "line_items_reconciliation_value_amount",
    label: "lineItems.reconciliation.value. amount",
    path: "lineItems[].reconciliation.value.amount",
  },
  // 83
  {
    id: "line_items_reconciliation_value_currency",
    label: "lineItems.reconciliation.value. currency",
    path: "lineItems[].reconciliation.value.currency",
  },
  // 84
  {
    id: "line_items_reconciliation_type",
    label: "lineItems.reconciliation. type",
    path: "lineItems[].reconciliation.type",
  },
  // 85
  {
    id: "line_items_reconciliation_quantity",
    label: "lineItems.reconciliation. quantity",
    path: "lineItems[].reconciliation.quantity",
  },
  // 86
  {
    id: "line_items_selected_additional_services_definition_id",
    label: "lineItems.selectedAdditionalServices. definitionId",
    path: "lineItems[].selectedAdditionalServices[].definitionId",
  },
  // 87
  {
    id: "line_items_selected_additional_services_name",
    label: "lineItems.selectedAdditionalServices. name",
    path: "lineItems[].selectedAdditionalServices[].name",
  },
  // 88
  {
    id: "line_items_selected_additional_services_price_amount",
    label: "lineItems.selectedAdditionalServices.price. amount",
    path: "lineItems[].selectedAdditionalServices[].price.amount",
  },
  // 89
  {
    id: "line_items_selected_additional_services_price_currency",
    label: "lineItems.selectedAdditionalServices.price. currency",
    path: "lineItems[].selectedAdditionalServices[].price.currency",
  },
  // 90
  {
    id: "line_items_selected_additional_services_quantity",
    label: "lineItems.selectedAdditionalServices. quantity",
    path: "lineItems[].selectedAdditionalServices[].quantity",
  },
  // 91
  { id: "line_items_vouchers_code", label: "lineItems.vouchers. code", path: "lineItems[].vouchers[].code" },
  // 92
  { id: "line_items_vouchers_type", label: "lineItems.vouchers. type", path: "lineItems[].vouchers[].type" },
  // 93
  { id: "line_items_vouchers_status", label: "lineItems.vouchers. status", path: "lineItems[].vouchers[].status" },
  // 94
  {
    id: "line_items_vouchers_external_transaction_id",
    label: "lineItems.vouchers. externalTransactionId",
    path: "lineItems[].vouchers[].externalTransactionId",
  },
  // 95
  {
    id: "line_items_vouchers_value_amount",
    label: "lineItems.vouchers.value. amount",
    path: "lineItems[].vouchers[].value.amount",
  },
  // 96
  {
    id: "line_items_vouchers_value_currency",
    label: "lineItems.vouchers.value. currency",
    path: "lineItems[].vouchers[].value.currency",
  },
  // 97
  { id: "line_items_tax_rate", label: "lineItems.tax. rate", path: "lineItems[].tax.rate" },
  // 98
  { id: "line_items_tax_subject", label: "lineItems.tax. subject", path: "lineItems[].tax.subject" },
  // 99
  { id: "line_items_tax_exemption", label: "lineItems.tax. exemption", path: "lineItems[].tax.exemption" },
  // 100
  { id: "line_items_bought_at", label: "lineItems. boughtAt", path: "lineItems[].boughtAt" },
  // 101
  { id: "surcharges_id", label: "surcharges. id", path: "surcharges[].id" },
  // 102
  { id: "surcharges_type", label: "surcharges. type", path: "surcharges[].type" },
  // 103
  { id: "surcharges_provider", label: "surcharges. provider", path: "surcharges[].provider" },
  // 104
  { id: "surcharges_finished_at", label: "surcharges. finishedAt", path: "surcharges[].finishedAt" },
  // 105
  {
    id: "surcharges_paid_amount_amount",
    label: "surcharges.paidAmount. amount",
    path: "surcharges[].paidAmount.amount",
  },
  // 106
  {
    id: "surcharges_paid_amount_currency",
    label: "surcharges.paidAmount. currency",
    path: "surcharges[].paidAmount.currency",
  },
  // 107
  {
    id: "surcharges_reconciliation_amount",
    label: "surcharges.reconciliation. amount",
    path: "surcharges[].reconciliation.amount",
  },
  // 108
  {
    id: "surcharges_reconciliation_currency",
    label: "surcharges.reconciliation. currency",
    path: "surcharges[].reconciliation.currency",
  },
  // 109
  { id: "surcharges_features", label: "surcharges. features", path: "surcharges[].features[]" },
  // 110
  { id: "discounts_type", label: "discounts. type", path: "discounts[].type" },
  // 111
  { id: "note_text", label: "note. text", path: "note.text" },
  // 112
  { id: "marketplace_id", label: "marketplace. id", path: "marketplace.id" },
  // 113
  {
    id: "summary_total_to_pay_amount",
    label: "summary.totalToPay. amount",
    path: "summary.totalToPay.amount",
    fallback: (order) => order.selling_price,
  },
  // 114
  {
    id: "summary_total_to_pay_currency",
    label: "summary.total.ToPay. currency",
    path: "summary.totalToPay.currency",
  },
  // 115
  { id: "updated_at", label: "updatedAt", path: "updatedAt" },
  // 116
  { id: "revision", label: "revision", path: "revision" },
];

export const DEFAULT_VISIBLE_COLUMN_IDS = ALLEGRO_COLUMN_SPECS.map((spec) => spec.id);

export const FILTER_COLUMN_IDS = {
  status: "status",
  fulfillmentStatus: "fulfillment_status",
  deliveryMethod: "delivery_method_name",
  buyerLogin: "buyer_login",
  smart: "delivery_smart",
};
